import algoliasearch from 'algoliasearch/lite';

const defaultApiKey = "6013a8c129ed3e33a015b035666333e7"
export const getClient = (apiKey?: string) => algoliasearch('EH8F0C9SE9', apiKey || defaultApiKey)

